const questions = [
  {
    id: 1,
    title: "Is Next JS backend, frontend, or full-stack?",
    info: "Next JS is full-stack. This means that it allows rendering client-side as well as server-side content. And this is the reason it is highly valued on React, as React allows only frontend development without it.",
  },
  {
    id: 2,
    title: "What do you mean by SSR?",
    info: "This is server-side rendering. This enables rendering on the server a client-side page app, and then we can send that rendered page to that client. These pages get loaded faster as the browser gets access to them sooner.",
  },
  {
    id: 3,
    title: "What do you mean by automatic code-splitting?",
    info: "Each page bundles as well as serves every import declared by us. And therefore, unnecessary code is never loaded on the pages.",
  },
  {
    id: 4,
    title: "What is DOM?",
    info: "DOM that is, Document Object Model, is HTML elements' object representation. The user interface and our code are kind of bridged by it. And it contains a tree-like structure having relationships such as child and parent.",
  },
  {
    id: 5,
    title: "Can you use Next JS with Redux?",
    info: "Yes, it is possible to use Next JS with Redux.",
  },
];
export default questions;
